// extracted by mini-css-extract-plugin
export default {"products-container":"products-list_products-container__qAto3","title-container":"products-list_title-container__2kxAt","products-title":"products-list_products-title__aXuX8"};